import React, { useEffect } from 'react';
//import { getValues } from './AmortizationFunctions';
import { TableContainer, Table, TableHead, TableRow, withStyles, Paper, makeStyles, TableCell, TableBody, Typography, Grid, Button } from '@material-ui/core';
//import { getCreditInformation } from './../../actions/digitalCredit';
import moment from 'moment';

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  buttonOk: {
    color: 'white',
    backgroundColor: '#2E2757',
    "&:hover": {
      color: 'white',
      backgroundColor: '#2E2757',
    },
  },
  buttonStandard: {
    fontSize: '1rem',
    color: '#ffffff',
    borderRadius: '4px',
    '&.Mui-disabled': {
        backgroundColor: "#a7a8a8",
    },
    '&:hover': {
        backgroundColor: "#706D85",
    },
    backgroundColor: "#2E2757",
    //fontFamily: 'MyriadPro-Bold',
},

});
const AmortizationTable = props => {
  const { amount, timeLimit, /* diference, handleOpenSnack, */ getBack, getNext, score, /* validar, getInformation */ } = props
  //console.log('score', score)
  const [dataTable, setDataTable] = React.useState({
    data: '',
    tableData: []
  });
  const classes = useStyles();

  /* const getInformation = async (idRequest) => {
    await getCreditInformation({
      identificadorUnicoSolicitud: idRequest
    }).then(response => {
      // console.log('response', response)
      // console.log(response.payload.data)
      setCreditOptions(response.payload.data)
      return true
    }).catch(
      error => {
        // console.log(error)
        return false
      }
    )
  } */

  const mount = () => {
    const unmount = () => {
      //const amortizationTable = getValues(amount, 14.5, timeLimit)
      /* const amortizationTable = getInformation(score.identificadorUnicoSolicitud)
      // console.log('amortizationTable', amortizationTable) */
     /*  const amortizationTable = getInformation(score.identificadorUnicoSolicitud)
      // console.log('amortizationTableResult', amortizationTable) */
      //validar(score)
      /* if (parseFloat(amortizationTable.data.pagoMensual) > diference) {
        handleOpenSnack('Sus ingresos y gastos no permiten el valor de la cuota seleccionada, escoja un monto mas bajo o un plazo mas largo ')
        getBack(dataTable)
      } */

      setDataTable(score)
    }
    return unmount()
  }
  useEffect(mount, [amount, timeLimit])

  //console.log('dataTable', dataTable)
  //return (<div>hola</div>)
  return (
    <div>
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <Typography component="p" variant="body1" align="justify">
            {`Por su capacidad de pago la cantidad de préstamo es la siguiente: `}
            <b>${dataTable.montoAprobado}</b>
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <Typography component="p" variant="body1" align="justify">
            <b>{`Monto del préstamo: `} </b>{`${dataTable.montoAprobado} `}<br />
            <b>{`Taza de interés: `}</b>{`${dataTable.tasaInteres} `}<br />
            <b>{`Numero de meses: `}</b>{`${dataTable.numeroCuotas} `}<br />
            <b>{`Pago mensual: `}</b>{`${dataTable.valorCuota} `}<br />
            <b>{`Total pagado: `}</b>{`${dataTable.totalPago} `}<br />
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>No.</StyledTableCell>
                  <StyledTableCell align="right">Fecha de pago</StyledTableCell>
                  <StyledTableCell align="right">Capital</StyledTableCell>
                  <StyledTableCell align="right">Interés</StyledTableCell>
                  <StyledTableCell align="right">Seguro Desgravamen</StyledTableCell>
                  <StyledTableCell align="right">Abono Cap.</StyledTableCell>
                  <StyledTableCell align="right">Cuota.</StyledTableCell>
                  <StyledTableCell align="right">Saldo Capital</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataTable.tablaPagos?.map((row) => (
                  <StyledTableRow key={row.numeroCuota}>
                    <StyledTableCell component="th" scope="row">{row.numeroCuota}</StyledTableCell>
                    <StyledTableCell align="right">{moment(row.fechaPago).format('YYYY-MM-DD')}</StyledTableCell>
                    <StyledTableCell align="right">{row.valorCapital}</StyledTableCell>
                    <StyledTableCell align="right">{row.valorInteres}</StyledTableCell>
                    <StyledTableCell align="right">{row.valorSeguro}</StyledTableCell>
                    <StyledTableCell align="right">{row.valorCapital}</StyledTableCell>
                    <StyledTableCell align="right">{row.valorTotal}</StyledTableCell>
                    <StyledTableCell align="right">{row.saldoCapitalEnCuota}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Button variant="contained" onClick={getNext}
            fullWidth
            style={{ height: '100%' }}
            className={classes.buttonStandard}
          // disabled={!valid}
          >
            Continuar
          </Button>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Button variant="contained" onClick={getBack}
            fullWidth
            style={{ height: '100%' }}
            className={classes.buttonStandard}
          // disabled={invalid }
          >
            Atras
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

AmortizationTable.propTypes = {
  //getCreditInformation
};

export default AmortizationTable;